import React from 'react'
import * as d3 from 'd3'
import d3Tip from 'd3-tip'

class BarChart extends React.Component {
    componentDidMount() {
        this.initChart(this.container, this.props)
    }

    componentWillReceiveProps(nextProps) {
        // render chart with new data
        this.renderChart(nextProps.data)
    }

    initChart = (el, props) => {
        const { data=[] } = this.props
        this.width  = props.width  || 720
        this.height = props.height || 190
        this.margin = props.margin || {top: 5, right: 20, bottom: 30, left: 40}

        // create svg container
        this.svg = d3.select(el).append('svg')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('class', 'calendar-dayview')

        // create scales
        this.x = d3.scaleBand().rangeRound([0, this.width - this.margin.left - this.margin.right]).padding(0.05)
        this.y = d3.scaleLinear().rangeRound([this.height - this.margin.top - this.margin.bottom, 0])

        // create padded middle container
        this.g = this.svg.append("g")
            .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")")

        // create x axis
        this.xAxis = d3.axisBottom(this.x)
        this.xAxisContainer = this.g.append("g")
            .attr("class", "axis axis--x")
            .attr("transform", "translate(0," + (this.height - this.margin.top - this.margin.bottom) + ")")
            .call(this.xAxis)

        // create y axis
        this.yAxis = d3.axisLeft(this.y).ticks(10)
        this.yAxisContainer = this.g.append("g")
            .attr("class", "axis axis--y")
            .call(this.yAxis)

        // TODO: y axis label? "Hours" - needs to be positioned correctly
        // this.yAxisContainer
        //     .append("text")
        //     .attr("transform", "rotate(-90)")
        //     .attr("y", 6)
        //     .attr("dy", "0.71em")
        //     .text("Hours")

        // setup tooltips
        this.tip = d3Tip()
            .attr('class', 'd3-tip')
            // .offset([5, 0])
            .offset([-10, 0])
            .direction('n')
            .html(d => "<span style='font-size: 75%'><strong>" + d.value + "</strong> " + this.props.valueLabel + "</span>")
        this.svg.call(this.tip)

        // render chart with initial data
        this.renderChart(data)
    }

    renderChart = (data) => {
        this.x.domain(data.map(function(d) { return d.label }))
        this.y.domain([0, d3.max(data, function(d) { return d.value })])

        this.xAxisContainer.call(this.xAxis)
        this.yAxisContainer.call(this.yAxis)

        // bars
        const bars = this.g.selectAll(".bar")
            .data(data)

        bars.enter()
            .append("rect")
            .attr("class", "bar")
            .on('mouseover', d => this.tip.show(d))
            .on('mouseout', this.tip.hide)
            .merge(bars)
            .attr("x", d => this.x(d.label) )
            .attr("y", d => this.y(d.value) )
            .attr("width", this.x.bandwidth())
            .attr("height", d => (this.height - this.margin.top - this.margin.bottom) - this.y(d.value) )

        bars.exit().remove()
    }

    render() {
        return (
            <div className="bar-chart" ref={(div) => { this.container = div }}></div>
        )
    }
}

export default BarChart


// WEBPACK FOOTER //
// ./src/components/bar_chart.jsx